
import { Input } from "element-ui"
import tooltip from "@/components/tooltip.vue"
export default {
  name: "CartInputNumber",
  components: {
    tooltip,
    [Input.name]: Input
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    maxlength: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plusDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curValue: this.value.count,
      focused: false
    }
  },
  computed: {
    increaseDisabled() {
      return this.plusDisabled || Number(this.curValue) >= this.max
    }
  },
  watch: {
    value: {
      handler() {
        this.curValue = this.value.count
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleInput(value) {
      this.curValue = value.replace(/[^\d]/g, "")
      if (this.curValue == 0) {
        this.curValue = ""
      }
    },
    handleBlur() {
      this.focused = false
    },
    handleFocus() {
      this.focused = true
    },
    reduce() {
      if (this.disabled) return

      this.curValue = Number(this.curValue) - 1
      this.handleChange(this.curValue)
    },
    increase() {
      if (this.disabled || this.increaseDisabled) return

      this.curValue = Number(this.curValue) + 1
      this.handleChange(this.curValue)
    },
    handleChange(value, type) {
      if (value === "") {
        this.curValue = value = this.min
      } else if (Number(value) > this.max) {
        this.curValue = value = this.max
        this.$emit("handleOverMaximum")
      }
      console.log("handleChange===>", Number(value), this.curValue)
      if (this.focused) {
        this.$refs.input && this.$refs.input.blur()
      }
      this.$emit("handleNumChange", Number(value))
    }
  }
}
